import { InventoryPrioritiesColumn } from './InventoryPrioritiesColumn';
import { PendingConfirmationColumn } from './PendingConfirmationColumn';
import { RequestForQuotesColumn } from './RequestForQuotesColumn';
import { ShippingSoonColumn } from './ShippingSoonColumn';

export function BuyerDashboard() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      <InventoryPrioritiesColumn />
      <PendingConfirmationColumn />
      <ShippingSoonColumn />
      <RequestForQuotesColumn />
    </div>
  );
}
